<template>
  <button
    type="button"
    class="lcu-iconButton"
    :class="[classes, [icon], {
      'lcu-iconButton-secondary': type === 'secondary',
      'lcu-iconButton-border': border,
      'lcu-iconButton-onLoad': loading,
      'lcu-button-disabled': disabled,
    }]"
    @click.prevent.stop="onClick"
    :disabled="disabled"
    :name="name">
    <span v-if="loading" class="lcu-iconButton-loading"></span>
  </button>
</template>

<script>
export default {
  name: 'icon-button-cta',
  props: {
    name: {
      type: String,
      required: false,
    },
    border: {
      type: Boolean,
      required: false,
      default: false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    type: {
      type: String,
      required: false,
    },
    classes: {
      type: Array,
      required: false,
      default: () => [],
    },
    icon: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    onClick() {
      this.$emit('on-click');
    },
  },
};
</script>

<style scoped lang="scss">
.lcu-iconButton {
    border: 0;
    font-size: 16px;
    color: $legacy-primary;
    background-color: transparent;
    border-radius: 3px;
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition-duration: .1s;

  &:before {
      display: inline-block;
      font-family: 'lcu';
  }

  &:hover {
      cursor: pointer;
      transform: translateY(-1px);
  }
}

.lcu-iconButton-border {
  border: 2px solid $legacy-primary;

  &:hover {
    background-color: $legacy-primary;
    color: $white;
  }
}

.lcu-iconButton-secondary {
  background-color: $legacy-secondary;

  &.lcu-button-border {
    background-color: transparent;
    border: 2px solid $legacy-secondary;
    color: $legacy-secondary;

    &:hover {
      background-color: $legacy-secondary;
      color: $white;
    }
  }
}

.lcu-iconButton-loading {
  animation: rotation 1s linear infinite;
  display: inline-block;

  &:before {
    content: '\e816';
    font-family: 'lcu';
    font-size: 21px;
  }
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.lcu-iconButton-onLoad {

  // in case any added class icons exist
  &:after {
    content: '' !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    display: none !important;
  }

  &:before {
    content: '' !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    display: none !important;
  }
}

.lcu-iconButton-delete {
  background-color: $danger;
  border: 0;
  color: $white;
  margin-left: 5px;
  padding: 10px;
  transition-duration: .1s;

  &:hover {
    background-color: #ee4545;
    cursor: pointer;
    transform: translateY(-1px);
  }
}

.lcu-button-disabled {
  opacity: 0.5;

  &:hover {
    cursor: not-allowed;
  }
}
</style>
